<template>
  <div class="navigation">
    <div class="navigationlist">
      <div
        v-for="(v, k) in muselist.lists"
        :key="k"
        class="meys cursor_pointer"
        @click="jum(k)"
        v-if="v"
        :style="{ color: inkdes == k ? 'white' : '#b5b5b5' }"
      >
        {{ v }}
        <div class="wybk" v-if="inkdes == k"></div>
        <div class="wybks" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      list: [
        { path: "/equipmentmsg/equipmentmsgs", lists: ["", "", ""] },
        { path: "/inoutlibrary/inoutlibrarys", lists: [] },
        { path: "/userlist/userlists", lists: [] },
        { path: "/basicsmsg/basicsmsgs", lists: [] },
        {
          path: "/detail/personal",
          lists: ["个人资料", "修改密码", "手机号", "关于我们"],
        },
      ],
      muselist: {},
      inkdes: 0,
    };
  },
  watch: {
    $route() {
      this.updateNavigation();
    },
  },
  mounted() {
    this.initializeNavigation();
  },
  methods: {
    initializeNavigation() {
      let menuData = JSON.parse(localStorage.getItem("menuList"));
      let menuList = menuData.menuList;
      let orgLevel = menuData.orgLevel;
      let isAdmin = menuData.isAdmin == "1";

      menuList.forEach((v) => {
        if (v.menuId == "80") this.list[0].lists[0] = "设备列表";
        if (v.menuId == "80") this.list[0].lists[1] = "维保列表";
        // if (v.menuId == "80") this.list[0].lists[2] = "强制操作";
        if (v.menuId == "2049") this.list[1].lists[0] = "出库单";
        if (v.menuId == "2049") this.list[1].lists[1] = "入库单";
        if (v.menuId == "150") this.list[2].lists[0] = "角色列表";
        if (v.menuId == "150") this.list[2].lists[1] = "账号列表";
        console.log(orgLevel, "orgLevelorgLeve");
        console.log(isAdmin, "isAdmin");
        if (isAdmin) {
          if (v.menuId == "2050") this.list[3].lists[0] = "层级信息";
          if (v.menuId == "2050") this.list[3].lists[1] = "设备信息";
          if (v.menuId == "2050") this.list[3].lists[2] = "项目工程";
          if (v.menuId == "2050") this.list[3].lists[3] = "二级单位";
          // if (v.menuId == "2050") this.list[3].lists[4] = "站点信息";
          // if (v.menuId == "2050") this.list[3].lists[5] = "故障信息";
        } else {
          if (orgLevel == "1") {
            if (v.menuId == "2050") this.list[3].lists[0] = "层级信息";
            if (v.menuId == "2050") this.list[3].lists[1] = "设备信息";
            if (v.menuId == "2050") this.list[3].lists[2] = "项目工程";
            // if (v.menuId == "2050") this.list[3].lists[5] = "故障信息";
          } else if (orgLevel == "2") {
            if (v.menuId == "2050") this.list[3].lists[0] = "层级信息";
            if (v.menuId == "2050") this.list[3].lists[1] = "设备信息";
            if (v.menuId == "2050") this.list[3].lists[2] = "项目工程";
            // if (v.menuId == "2050") this.list[3].lists[3] = "二级单位";
            // if (v.menuId == "2050") this.list[3].lists[5] = "故障信息";
          } else if (orgLevel == "3") {
            if (v.menuId == "2050") this.list[3].lists[0] = "层级信息";
            if (v.menuId == "2050") this.list[3].lists[1] = "设备信息";
            if (v.menuId == "2050") this.list[3].lists[2] = "项目工程";
            // if (v.menuId == "2050") this.list[3].lists[4] = "站点信息";
            // if (v.menuId == "2050") this.list[3].lists[5] = "故障信息";
          }
        }
        // 基础信息菜单只有当orgLevel=1时才显示
        // if(orgLevel == 1) {

        // }
      });
      console.log(this.list, "--->this.list@@@@@@@@@@@@");

      this.updateNavigation();
    },
    updateNavigation() {
      console.log(this.list, "--->this.list!!!!!!!");

      this.list.forEach((v) => {
        if (v.path == this.$route.path) {
          this.muselist = v;
        }
      });
      console.log(this.muselist, "this.muselist22222222222--->");

      this.getindesx();
    },
    getindesx() {
      if (this.$route.query.index) {
        this.inkdes = this.$route.query.index;
      } else {
        try {
          this.muselist.lists.forEach((v, k) => {
            if (v != "") {
              this.inkdes = k || 0;
              throw new Error("cw");
            }
          });
          console.log(this.muselist, "--->this.muselist#######");
        } catch (error) {
          return;
        }
      }
    },
    jum(k) {
      this.inkdes = k;
      this.$router.push({
        path: this.muselist.path,
        query: { index: k },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.navigation {
  background-color: #fff;
  padding: 8px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 0 0 12px;
  max-width: 100%;

  .navigationlist {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .meys {
    color: #606266;
    padding: 6px 12px;
    background-color: #f4f4f5;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-size: 14px;
    position: relative;
    display: inline-flex;
    align-items: center;

    &:hover {
      background-color: #ecf5ff;
      color: #409eff;
    }

    &[style*="color: white"] {
      background-color: #409eff;
      color: white !important;
    }
  }

  .wybk,
  .wybks {
    display: none;
  }
}
</style>
